import type { NotifLang } from '@/types/admin.types';
import {
  CATALOG_LANGS, mergeMissing, type FilledMap, type LangTexts,
} from '@/views/AdminView/tabs/TemplatesTab/catalogTranslation';

/**
 * Puente entre los textos por idioma del Recap (`LocalizedText`, llaves que pueden faltar) y el
 * botón «Traducir a los demás idiomas» del Catálogo de Fundamentales (`CatalogTranslateButton`),
 * que trabaja con los 7 idiomas siempre presentes. Reusa su lógica tal cual: solo se llenan los
 * idiomas vacíos y una respuesta vacía de Azure se trata como error.
 */

/** Los 7 idiomas completos; el que no exista en `texts` cuenta como vacío. */
export function toLangTexts(texts: Record<string, string> | undefined): LangTexts {
  const out = {} as LangTexts;
  for (const lang of CATALOG_LANGS) out[lang] = texts?.[lang] ?? '';
  return out;
}

/**
 * Copia de `current` con lo traducido aplicado únicamente a los idiomas que sigan vacíos. No agrega
 * llaves que no cambian: así un `LocalizedText` sin tocar sigue siendo idéntico al que llegó del servidor.
 */
export function applyFilled(
  current: Record<string, string>,
  filled?: FilledMap[string],
): Record<string, string> {
  const merged = mergeMissing(toLangTexts(current), filled);
  const next = { ...current };
  for (const lang of CATALOG_LANGS) {
    if (merged[lang] !== (current[lang] ?? '')) next[lang] = merged[lang];
  }
  return next;
}

/** Idioma de la interfaz como origen preferido de la traducción (es-MX → es); `es` si no es uno de los 7. */
export function toNotifLang(code: string | undefined): NotifLang {
  const base = (code ?? '').toLowerCase().split('-')[0];
  return CATALOG_LANGS.find((lang) => lang === base) ?? 'es';
}
